import * as React from "react";

import { Grid, makeStyles } from "@material-ui/core";
import { TABSComments } from "../../static/tabsData";
import NewPublicSlidingTabs from "../../../../../common/tabBar/NewPublicSlidingTabs";
import { getApiService } from "../../../../../../services/AgapeAPI";
import TabsLoading from "../../static/TabsLoading";
import UserComment from "./components/UserComment";
import UserCreateComment from "./components/UserCreateComment";
import UserRate from "./components/UserRate";
import UserCreateRate from "./components/UserCreateRate";

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#fff",
    boxShadow: "0px 2px 15px 0px #0001",
    borderRadius: "10px",
    margin: "10px auto",
    padding: "20px 10px",
  },
  p: {
    padding: 10,
  },
}));

const OrganizationUserComments = ({
  userRate,
  isMobile,
  code,
  getData,
  ...props
}) => {
  const classes = useStyles();

  const [tab, setTab] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  // data =>
  const [comments, setComments] = React.useState({});
  const [rate, setRate] = React.useState({});

  const getComments = () => {
    getApiService(`pub/organizations/${code}/comments`).then((res) => {
      setComments(res.data.data);
      setLoading(false);
    });
  };

  React.useEffect(() => {
    setLoading(true);
    switch (tab) {
      case 0:
        getComments();
        break;

      // case 1:
      //   getApiService(`pub/organizations/${code}/mission-vision`).then(
      //     (res) => {
      //       setEye(res.data.data);
      //       setLoading(false);
      //     }
      //   );
      //   break;

      case 2:
        getApiService(`pub/organizations/${code}/users-scores`).then((res) => {
          setRate(res.data.data);
          setLoading(false);
        });
        break;

      // case 3:
      //   getApiService(`pub/organizations/${code}/members`).then((res) => {
      //     setMembers(res.data.data);
      //     setLoading(false);
      //   });
      //   break;

      default:
        setLoading(false);
        break;
    }
  }, [tab]);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  const components = [
    <UserComment getComments={getComments} comments={comments} />,
    <UserCreateComment code={code} />,
    <UserRate rate={rate} />,
    <UserCreateRate code={code} userRate={userRate} getData={getData} />,
  ];

  return (
    <Grid container className={classes.container}>
      <Grid item xs={2} className={classes.p}>
        <NewPublicSlidingTabs
          data={TABSComments}
          tab={tab}
          setTab={setTab}
          handleTabChange={handleChange}
        />
      </Grid>
      <Grid item xs={10}>
        {loading ? <TabsLoading /> : components[tab]}
      </Grid>
    </Grid>
  );
};

export default OrganizationUserComments;
